import React, { SyntheticEvent, useCallback, useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { LifePart } from "../../state/LifePart";
import { emptyLifepart, getRandomColor } from "../../state/reducer";
import { useData } from "@/storage/accessors";
import { useNavigate } from "react-router";
import useWheelId from "@/hooks/useWheelId";
import ColorPicker from "./ColorPicker";

type Props = {
    popup: boolean;
    toggle: () => void;
    onSave?: (lifePart: LifePart) => void;
};

export default function LifePartSimpleModal({ popup, toggle, onSave }: Props) {
    const navigate = useNavigate();
    const wheelId = useWheelId();
    const { roles } = useData();
    const [name, setName] = useState("");
    const [color, setColor] = useState(getRandomColor());
    const inputRef = useRef<HTMLInputElement>(null);

    const rolesList = Object.values(roles.objects);

    const handleCreate = useCallback(() => {
        const maxOrder = rolesList.length > 0
            ? Math.max(0, ...rolesList.map(p => p.order || 0))
            : 0;
        const newPart: LifePart = {
            ...emptyLifepart(),
            name,
            color,
            startpoint: 1,
            order: maxOrder + 1
        };
        roles.create(newPart);

        toggle();
        if (onSave) onSave(newPart);
    }, [roles, rolesList, toggle, onSave, name, color]);

    const saveForm = useCallback((e?: SyntheticEvent) => {
        if (e) {
            e.preventDefault();
        }
        handleCreate();
    }, [handleCreate]);

    useEffect(() => {
        if (popup) {
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.select();
                }
            }, 100);
        }
    }, [popup]);

    // Сброс формы при открытии
    useEffect(() => {
        if (popup) {
            setName("");
            setColor(getRandomColor());
        }
    }, [popup]);

    return (
        <Modal show={popup} onHide={toggle}>
            <Modal.Header>Добавить</Modal.Header>
            <Modal.Body>
                <Form onSubmit={saveForm}>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Название</Form.Label>
                                <Form.Control type="text" value={name} onChange={(e: any) => setName(e.target.value)} ref={inputRef} />
                            </Form.Group>
                            <Form.Group className="d-flex align-items-center gap-2 mt-3">
                                <Form.Label className="mb-0">Цвет</Form.Label>
                                <ColorPicker value={color} onChange={setColor} />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={toggle}>
                    Отмена
                </Button>
                <Button variant="outline-success" onClick={saveForm}>
                    Добавить
                </Button>
            </Modal.Footer>
        </Modal>
    );
}